import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { Form1Component } from './modules/forms/components/form1/form1.component';
import { Form2Component } from './modules/forms/components/form2/form2.component';
import { Form3Component } from './modules/forms/components/form3/form3.component';
import { Form4Component } from './modules/forms/components/form4/form4.component';
import { Form5Component } from './modules/forms/components/form5/form5.component';
import { Form6Component } from './modules/forms/components/form6/form6.component';
import { LoginModule } from './modules/login/login.module';
import { PopupComponent } from './shared/components/popup/popup.component';
import { FirstLoginComponent } from './modules/login/components/first-login/first-login.component';
import { ClientSelectionComponent } from './modules/login/components/client-selection/client-selection.component';
import { AuthenticationComponent } from './modules/login/components/authentication/authentication.component';
import { ResetpasswordComponent } from './modules/login/components/Reset-Password/Reset-Password.component';
import { FirstLoginPasswordResetComponent } from './modules/login/components/first-login-passwordreset/first-login-passwordreset.component';


const routes: Routes = [];

routes.push(
  {
    path: '',
    redirectTo: "login/app-authentication",
    pathMatch: 'full'
  },
  {
    path: 'login/app-authentication',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'client-selection',
    component: ClientSelectionComponent
  },

  {
    path: 'first-login',
    component: FirstLoginComponent
  },

  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'forms',
    loadChildren: () => import('./modules/forms/forms.module').then(m => m.FormsDeclarationModule)
  },
  {
    path: 'form1',
    component: Form1Component
  },
  {
    path: 'form2',
    component: Form2Component
  },
  {
    path: 'form3',
    component: Form3Component
  },
  {
    path: 'form4',
    component: Form4Component
  },
  {
    path: 'form5',
    component: Form5Component
  },
  {
    path: 'form6',
    component: Form6Component
  },
  {
    path: 'popup',
    component: PopupComponent
  },
  {
    path: 'authentication',
    component: AuthenticationComponent
  },
  { path: 'app-reset-password',
   component: ResetpasswordComponent
   },
  {
    path:'app-first-login-passwordreset',
    component: FirstLoginPasswordResetComponent
  }
);


@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
